export enum ProjectPermission {
  DraftMessaging = 3,
  EmailChannel = 23,
  EmbeddedChannel = 28,
  PushInAppChannel = 25,
  ManageBaseTemplates = 1,
  ManageCatalogs = 2,
  ManageChannelConfiguration = 20,
  ManageGoals = 21,
  ManageIntegrations = 11,
  ManageMessaging = 4,
  ManageProjectSettings = 14,
  ManageReports = 8,
  ManageSegmentation = 16,
  ManageSnippets = 17,
  ManageUserProfiles = 5,
  PushChannel = 24,
  SMSChannel = 27,
  ViewAndExportUserData = 6,
  ViewCatalogs = 13,
  ViewChannelConfiguration = 18,
  ViewGoals = 22,
  ViewMessaging = 9,
  ViewReports = 12,
  PushWebChannel = 26,
  CampaignMediumsGroup = 100,
  WhatsAppChannel = 29,
}
